import React, { useEffect, useRef, useState } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import Container from '../../../../components/Container'
import api from '../../../../services/api'
import { useToast } from '../../../../hooks/toast'
import { useLoading } from '../../../../hooks/loading'
import { Alert } from '../../../../components/Alert'
import {
  nameActions,
  ROUTE_PRIORITY_ENUM,
  ROUTE_PRIORITY_MAP,
  ROUTE_STATUS_ENUM,
  ROUTE_STATUS_MAP
} from '../domain/info'
import { apiDelete, apiList } from '../domain/api'
import { apiDelete as apiDeleteRouteAgency } from '../../RoutesAgencies/domain/api'
import { nameSource as nameSourceRoutesAgencies } from '../../RoutesAgencies/domain/info'
import { headers as headersRoutesAgencies } from '../../RoutesAgencies/domain/headers'

import { breadcrumbView } from '../domain/breadcrumb'
import {
  toolsViewCreate,
  toolsViewDelete,
  toolsViewUpdate,
  toolsViewList
} from '../domain/tools'
import Tabs from '../../../../components/Tabs'
import Tab from '../../../../components/Tabs/Tab'
import DataTableForCustomPaginationRoute from '../../../../components/DataTableForCustomPaginationRoute'
import Modal from '../../../../components/Modal'
// import { FormRouteAgency } from '../../RoutesAgencies/components/Form'
import { useUpdateDataTable } from '../../../../hooks/dataTable'
import {
  FormRouteAgency,
  RouteAgencyData
} from '../../RoutesAgencies/components/Form'

type RouteData = {
  id?: string
  promoter_id: number
  name: string
  scheduled_date: string
  priority: ROUTE_PRIORITY_ENUM
  observation?: string | null
  status: ROUTE_STATUS_ENUM
  completed_at?: Date | null
  promoter: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

const RouteView = (): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const location = useLocation()
  const { updateDataTable } = useUpdateDataTable()
  const [route, setRoute] = useState<RouteData | null>(null)
  const { addToast } = useToast()
  const [alertRemove, setAlertRemove] = useState<{
    open: boolean
  }>({
    open: false
  })

  const searchParameters = useRef([{ route_id: id }])

  const { disableLoading, activeLoading } = useLoading()

  useEffect(() => {
    async function loadRoute(): Promise<void> {
      activeLoading()
      try {
        const response = await api.get<RouteData>(apiList(id))
        const { data } = response
        setRoute(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar a rota',
          description:
            'Houve um error ao carregar a rota, tente novamente mais tarde!'
        })
        if (path.includes('view')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadRoute()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  const handlerClickButtonCancellAlert = () => {
    setAlertRemove({
      open: false
    })
    addToast({
      type: 'info',
      title: 'Operação cancelada.'
    })
  }

  const handlerClickButtonConfirmAlert = async (id: string) => {
    try {
      await api.delete(apiDelete(id))
      setAlertRemove({
        open: false
      })
      addToast({
        type: 'success',
        title: 'Agência removida com sucesso.'
      })
      history.goBack()
    } catch (err) {
      setAlertRemove({
        open: false
      })
      addToast({
        type: 'error',
        title: 'Agência não removida, pois ainda está sendo usada.'
      })
    }
  }

  const [alertRemoveRouteAgency, setAlertRemoveRouteAgency] = useState<{
    open: boolean
    id?: number
    name?: string
  }>({
    open: false
  })

  const handleOnClickRemoveRouteAgency = (id: number, name: string) => {
    setAlertRemoveRouteAgency({
      id,
      open: true,
      name
    })
  }

  const handleOnClickRemove = () => {
    setAlertRemove({
      open: true
    })
  }

  const handlerOnClickButtonConfirmRemoveRouteAgency = async (id: number) => {
    try {
      await api.delete(apiDeleteRouteAgency(String(id)))
      setAlertRemoveRouteAgency({
        open: false
      })
      addToast({
        type: 'success',
        title: 'Agência removido com sucesso.'
      })
      updateDataTable()
    } catch (err: any) {
      setAlertRemoveRouteAgency({
        open: false
      })
      if (err.response.status === 403) {
        addToast({
          type: 'error',
          title: err.response.data.message
        })
        return
      }
      addToast({
        type: 'error',
        title: 'Agência não removido, pois ainda está sendo usada.'
      })
    }
  }

  const handlerOnClickButtonCancelRemoveRouteAgency = () => {
    setAlertRemoveRouteAgency({
      open: false
    })
  }

  const [modalCreateRouteAgency, setModalCreateRouteAgency] = useState(false)
  const [modalEditRouteAgency, setModalEditRouteAgency] = useState(false)

  const [currentItemEdit, setCurrentItemEdit] = useState<any>({} as any)

  const handleClickOnClose = () => {
    setModalCreateRouteAgency(false)
    setModalEditRouteAgency(false)
  }

  const handleClickOnOpenModalCreate = () => {
    setModalCreateRouteAgency(true)
  }

  const handleClickOnOpenModalEdit = (item: RouteAgencyData) => {
    setCurrentItemEdit({
      route_id: id,
      agency_id: item.agency_id,
      priority: item.priority,
      agency: item.agency,
      observation: item.observation,
      id: item.id
    })
    setModalEditRouteAgency(true)
  }

  return (
    <>
      <Container
        pageTitle={nameActions.read.name}
        breadcrumb={breadcrumbView}
        tools={[
          {
            name: 'Clonar',
            to: `/partnerships/routes/create?route_id=${id}`,
            icon: 'fa fa-copy',
            color: 'btn-light-info'
          },
          toolsViewUpdate(String(id)),
          toolsViewDelete(() => {
            handleOnClickRemove()
          }),
          toolsViewCreate(),
          toolsViewList()
        ]}
      >
        <div className="form-body">
          <div className="row mb-5">
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Cód.
                </label>
                <p className="fw-bolder fs-6 text-gray-800">{route?.id}</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Promotor
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {route?.promoter?.name}
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Nome
                </label>
                <p className="fw-bolder fs-6 text-gray-800">{route?.name}</p>
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Data
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {route?.scheduled_date.split('-').reverse().join('/')}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Prioridade
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {ROUTE_PRIORITY_MAP[route?.priority as ROUTE_PRIORITY_ENUM]}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Status
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {ROUTE_STATUS_MAP[route?.status as ROUTE_STATUS_ENUM]}
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                  Finalizado em
                </label>
                <p className="fw-bolder fs-6 text-gray-800">
                  {route?.completed_at}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-md-12">
            <div className="form-group">
              <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6 pre-line">
                Observações
              </label>
              <p
                className="fw-bolder fs-6 text-gray-800"
                style={{ whiteSpace: 'pre-line' }}
              >
                {route?.observation}
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                Cadastrado em
              </label>
              <p className="fw-bolder fs-6 text-gray-800">
                {route?.created_at}
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label className="col-form-label fw-bold fs-6form-label fw-bold fs-6">
                Atualizado em
              </label>
              <p className="fw-bolder fs-6 text-gray-800">
                {route?.updated_at}
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-8">
          <Tabs>
            <Tab title="Agências">
              <div className="card-header p-0 d-flex - align-items-center">
                <div className="card-title m-0 fw-bolder fs-6 text-gray-800"></div>
                <div
                  className=""
                  style={{
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'center'
                  }}
                >
                  <a
                    href="#"
                    onClick={handleClickOnOpenModalCreate}
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="fa fa-plus" /> Adicionar
                  </a>
                </div>
              </div>
              {
                <DataTableForCustomPaginationRoute
                  paginationUrl="partnerships/routesAgencies/pagination"
                  source={nameSourceRoutesAgencies}
                  headers={headersRoutesAgencies}
                  searchParameters={searchParameters.current}
                  notHasChildren
                  customHeaders={[
                    {
                      name: 'Prioridade',
                      field: 'priority',
                      sortable: false,
                      element: item => (
                        <span>
                          {
                            ROUTE_PRIORITY_MAP[
                              item.priority as ROUTE_PRIORITY_ENUM
                            ]
                          }
                        </span>
                      )
                    }
                  ]}
                  actions={[
                    {
                      name: 'Atualizar',
                      title: 'Atualizar',
                      element: item => {
                        return (
                          <span
                            className={'fa fa-edit'}
                            onClick={() => handleClickOnOpenModalEdit(item)}
                          ></span>
                        )
                      }
                    },
                    {
                      name: 'Remover',
                      title: 'Remover',
                      element: item => {
                        return (
                          <span
                            className={'fa fa-remove'}
                            onClick={() =>
                              handleOnClickRemoveRouteAgency(
                                item.id,
                                item.agency.name
                              )
                            }
                          ></span>
                        )
                      }
                    }
                  ]}
                />
              }
            </Tab>
            <></>
          </Tabs>
        </div>
      </Container>
      <Alert
        message={`Tem certeza que deseja excluir o registro ${route?.name} ?`}
        onClickCancellButton={handlerClickButtonCancellAlert}
        onClickConfirmButton={() => {
          handlerClickButtonConfirmAlert(String(route?.id))
        }}
        isActive={alertRemove.open}
      />
      <Alert
        message={`Tem certeza que deseja excluir o registro ${alertRemoveRouteAgency.name} ?`}
        onClickCancellButton={handlerOnClickButtonCancelRemoveRouteAgency}
        onClickConfirmButton={() =>
          handlerOnClickButtonConfirmRemoveRouteAgency(
            Number(alertRemoveRouteAgency.id)
          )
        }
        isActive={alertRemoveRouteAgency.open}
      />

      {modalCreateRouteAgency && (
        <Modal
          onClickButtonCancel={handleClickOnClose}
          isOpenModal={modalCreateRouteAgency}
          pageTitle={'Adicionar Agência'}
          style={{
            stylesModal: {
              minWidth: '60vw'
            }
          }}
          Children={
            <FormRouteAgency
              typeForm="create"
              promoter_id={route.promoter_id}
              isOpenInModal={{
                handleOnClose: handleClickOnClose,
                route_id: Number(id)
              }}
            />
          }
        />
      )}
      {modalEditRouteAgency && (
        <Modal
          onClickButtonCancel={handleClickOnClose}
          isOpenModal={modalEditRouteAgency}
          pageTitle={'Atualizar Agência'}
          style={{
            stylesModal: {
              minWidth: '60vw'
            }
          }}
          Children={
            <FormRouteAgency
              typeForm="update"
              promoter_id={route.promoter_id}
              initialValues={{
                ...currentItemEdit,
                idUpdate: currentItemEdit?.id
              }}
              isOpenInModal={{
                handleOnClose: handleClickOnClose,
                route_id: Number(id)
              }}
            />
          }
        />
      )}
    </>
  )
}

export default RouteView
